import Vue from 'vue'
import App from './App.vue'
import 'animate.css'
import './app.scss'
require('./mixin')



import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: process.env.VUE_APP_API_URL+'/img/system/no_cover.jpg',
  loading: process.env.VUE_APP_API_URL+'/img/system/loading.svg',
  attempt: 1
})

//polyfills
import VueObserveVisibility from 'vue-observe-visibility'
Vue.use(VueObserveVisibility)

import smoothScroll from 'smoothscroll-polyfill';
smoothScroll.polyfill();

import './res/modernizer';
//eof polyfills

Vue.config.productionTip = false

window.icons = require('./res/icons');
Vue.component('Unicon', require('./components/Unicon').default)


import router from './router'
import store from './store'
//
window.webp = false;
Modernizr.on('webp', (result)=> {
  window.webp=result;
  boot();
});

function boot(){
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}

